'use client';

import LegalDocumentView from '@/app/components/legal/LegalDocumentView';
import { PRIVACY_EMAIL } from '@/lib/legal/business';
import {
  PRIVACY_ADDITIONAL_NOTICE,
  PRIVACY_INTRO,
  privacySections,
} from '@/lib/legal/privacy-sections';

export default function PrivacyPolicyPage() {
  return (
    <LegalDocumentView
      title="Privacy Policy"
      subtitle="How we collect, use, and protect your personal information"
      intro={PRIVACY_INTRO}
      sections={privacySections}
      noticeTitle="Additional Information"
      noticeParagraphs={PRIVACY_ADDITIONAL_NOTICE}
      ctaTitle="Questions About Privacy?"
      ctaSubtitle="Contact us if you have any questions about our privacy practices."
      contactEmail={PRIVACY_EMAIL}
      crossLink={{ href: '/terms', label: 'View Terms of Use' }}
    />
  );
}
